/**
 * Guards MutationObserver.observe so extensions or legacy scripts cannot crash
 * the editor by passing non-Node targets. This mirrors fixes called out in
 * previous boot investigations and keeps console noise down for QA.
 */
const installMutationObserverGuard = () => {
  if (typeof window === 'undefined') return;
  const Observer = window.MutationObserver;
  if (!Observer || !Observer.prototype) return;

  const originalObserve = Observer.prototype.observe;
  if (typeof originalObserve !== 'function') return;

  let warned = false;

  const isNodeLike = (target: unknown): target is Node => {
    if (!target || typeof target !== 'object') return false;
    // Use loose duck-typing so we do not rely on Node existing (iframe quirks).
    return 'nodeType' in target && typeof (target as { nodeType: unknown }).nodeType === 'number';
  };

  Observer.prototype.observe = function patchedObserve(target: unknown, options?: MutationObserverInit) {
    if (!isNodeLike(target)) {
      if (!warned && typeof console !== 'undefined') {
        warned = true;
        console.warn('MutationObserver.observe skipped for non-node target', target);
      }
      return undefined;
    }
    return originalObserve.call(this, target as Node, options);
  };
};

installMutationObserverGuard();

export {};
